import { get, post, patch, destroy } from './httpClient'

export const getMenus = (query) => get('/menu', query)
export const addMenu = (body) => post('/menu/create', body)
export const updateMenu = (id, body) => patch('/menu/update/' + id, body)
export const deleteMenu = (ids) => destroy('/menu/delete', { menu_id: ids })
